<template>
  <div class="news">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/news_xwdt_banner.png"
        alt=""
      >
    </div>
    <div
      class="new_con w1200"
      v-for="(item,i) in newsCont"
      :key="i"
      v-if="$route.query.id - 0 === i"
    >
      <h4>{{item.title}}</h4>
      <span>{{item.date}}</span>
      <span>天津协和万邦</span>
      <img
        :src="item.img"
        alt=""
      >
      <p>{{item.text}}</p>
      <p>{{item.text1}}</p>
      <p v-if="$route.query.id != 1">{{item.text2}}</p>
      <p v-if="$route.query.id != 1" >{{item.text3}}</p>
      <p v-if="$route.query.id != 1 && $route.query.id !=3">{{item.text4}}</p>
      <p v-if="$route.query.id != 0 && $route.query.id !=1 &&$route.query.id !=3">{{item.text5}}</p>
      <p v-if="$route.query.id === 2 && $route.query.id ===4">{{item.text6}}</p>
      <p v-if="$route.query.id === 2 && $route.query.id ===4">{{item.text7}}</p>
      <p v-if="$route.query.id === 2">{{item.text8}}</p>
      <p v-if="$route.query.id === 2">{{item.text9}}</p>
      <p v-if="$route.query.id === 2">{{item.text10}}</p>
      <p v-if="$route.query.id === 2">{{item.text11}}</p>
      <p v-if="$route.query.id === 2">{{item.text12}}</p>
      <p v-if="$route.query.id === 2">{{item.text13}}</p>

    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      newsCont: [
        {
          id: 0,
          title: "强强联手 新模式开启新天地--项目合作圆满召开",
          date: "2018-12-05",
          img: require("../../static/img/news_xiangqing_ttu1.png"),
          text:
            "2018年12月05日，天津协和万邦保险经纪公司在公司大厦成功举办与北京飞猪科技公司项目合作启动大会，双方在通过科技创新的深度合作上迈出了实质性的一步。",
          text1:
            "公司董事长兼首席执行官、总裁和副总裁及总经理、副总经理出席会议。双方公司总部相关部门及多家试点机构的负责人和相关人员出席了会议。",
          text2:
            "公司董事长兼首席执行官为启动大会致辞，他表达了对天津协和万邦保险经纪团队一行的热烈欢迎，并给予高度赞誉，对双方的深入合作充满期待，并从经纪公司的角度提出了对现在市场的发展思考，通过回顾以往的发展历程，表示希望通过本次项目合作，共同攻克现在所面对的难题，不但做大规模，还要做出效益，做强品牌。",
          text3:
            "副总经理为启动大会致辞，他回顾了北京飞猪科技与天津协和万邦保险经纪深远的合作渊源，从多个方面阐述了本次项目合作的重要意义，肯定了这次项目在科技降损方面的创新成果，表示该项目符合现在所需要的使命，是使多方共赢的新型商业模式。",
          text4:
            "北京飞猪科技的副总经理对启动会议做了简短总结，要求试点机构要高度重视此次项目合作，积极推动项目落地，在细分领域专注深耕，采用新技术、新模式开拓发展的新天地，带动业务规模效益发展，抢抓发展的新机遇，实现共赢发展。"
        },
        {
          id: 1,
          title: "弘扬真善美 传递正能量 公司开展学雷锋志愿服务活动",
          date: "2018-11-20",
          img: require("../../static/img/news_xiangqing_tu2.png"),
          text:
            "11月20日，公司共产党员服务队、青年志愿者服务队联合都城管理中心前往浦东新区的残障疗养院开展学习雷锋主题日活动，以实际行动传承雷锋精神。在疗养院，志愿者们深入了解了残障人士的生活和身体情况，参观了疗养院中的复活动室、心理咨询室以及残障人士亲手制作的精美手工制品和绿色环保作品，感受到了他们积极的人生态度和自强自立的精神意志。",
          text1:
            "借此之际，志愿者们为他们送去了真诚的祝福和爱心物资，以实际行动充分发挥了共产党员、共青团员在志愿服务中的示范带头作用，切实把“雷锋精神”落在实处，推动“学雷锋”活动常态化开展，树立了公司良好形象。"
        },
        {
          id: 2,
          title: "防范非法集资小问答",
          date: "2018-09-18",
          img: require("../../static/img/news_xiangqing_tu3.png"),
          text: "**如何识别保险领域的非法集资？",
          text1:
            "解答：消费过程中要尽量做到“三查、两配合”，即通过保险公司网站、客户热线或保监会、行业协会网站查人员、查产品、查单证，配合做好转账缴费、配合做好回访。",
          text2: "** 一般非法集资有哪些特征？",
          text3:
            "解答：一般非法集资的特征是：一是未经有关部门依法批准或者借用合法经营的形式吸收资金；二是通过媒体、推介会、传单、手机短信等途径向社会公开宣传；三是承诺在一定期限内以货币、实物、股权等方式还本付息或者给付回报；四是向社会公众即社会不特定对象吸收资金。当前民间投融资中介机构、P2P网络借贷、农民合作社、房地产、私募基金等领域是非法集资的重灾区。",
          text4: "**一般非法集资有哪些犯罪伎俩？",
          text5:
            "解答：一般的非法集资犯罪伎俩为：“刚性兑付+高回报+政府背书（商业增信）”黄金三要素，即不法机构往往承诺一定期限内给予投资人还本付息，并允诺高额回报，同时或假借国家发展政策，或用地方政府批文、担保（保险）合同作为背书。 ",
          text6: "**非法集资有哪些危害？",
          text7:
            "解答：非法集资不可持续，犯罪分子通过欺骗手段聚集资金后，任意挥霍、浪费、转移或者非法占有，参与者很难收回资金。 ",
          text8: "**如何避免陷入非法集资陷阱？",
          text9:
            "解答：不相信高息“保险”，不被小礼品打动，不接收“先返息”之类的诱饵；不相信任何以保险公司资金运用、项目投资和购买股份等为名目并承诺高额利息或回报的借款行为；不与保险从业人员个人签订投资理财协议，不接收保险营销员个人出具的任何收据、欠条。",
          text10: "** 参与非法集资形成的风险及损失有谁来承担？",
          text11:
            "解答：根据法律规定，参与非法集资受到的损失，由参与者自行承担，参与者利益不受法律保护。 ",
          text12: "**正确的保险理念是什么？",
          text13:
            "解答：保险投资理财产品的年化收益率普遍在4%－5%左右，通过正规渠道购买保险产品，保险公司均会严格按照保单合同履行相应承诺。非法金融产品收益虽高，但高收益伴随高风险，天上不可能掉馅饼，不可能一夜暴富，切忌心存侥幸。"
        },
        {
          id: 3,
          title: "公司组织全体员工集中观看电影《厉害了，我的国》",
          date: "2018-06-15",
          img: require("../../static/img/news_xiangqing_tu4.png"),
          text:
            "06月15日，公司组织单位全体员工集中观看了大型纪录电影《厉害了，我的国》。",
          text1:
            "影片以习近平新时代中国特色社会主义思想为内在逻辑，展示了在创新、协调、绿色、开放、共享的新发展理念下中国这五年的伟大成就，展现了中国人民在全面建设小康征程上的伟大奋斗，彰显了以习近平同志为核心的党中央的正确领导，凝聚起全党全国人民的磅礴力量，为实现中华民族伟大复兴的中国梦不断前进。",
          text2:
            "影片记录了中国桥、中国路、中国车、中国港、中国网等一个个非凡的超级工程。从圆梦工程到创新科技，从绿色中国到共享小康，电影分享震撼影像的同时，也将其背后的故事娓娓道来，体现了“大国”与“小家”息息相关、密不可分，描绘了一幅幸福民生的壮美画卷。",
          text3:
            "走进新时代，立足新起点，创造新辉煌。大家纷纷表示，作为一名公司员工的一员，今后将不忘初心，牢记使命，为建设具有卓越竞争力的世界一流保险经纪企业贡献自己的力量。"
        },
        {
          id: 4,
          title: "防控风险 守住底线",
          date: "2017-09-12",
          img: require("../../static/img/news_xiangqing_tu5.png"),
          text:
            "保险业是经营风险的特殊行业。最近，中国保监会发出《关于进一步加强保险业风险防控工作的通知》，内容涉及9项风险十大举措，核心紧扣保险业的风险防范。在当前中国经济、中国金融面临诸多复杂不利局面的形势下，出台这样一个防控保险业风险的文件可谓正逢其时。",
          text1:
            "去年12月召开的中央经济工作会议，为今年经济格局的把握定了一个调。会议指出，要把防控金融风险放到更加重要的位置，下决心处置一批风险点，着力防控资产泡沫，提高和改进监管能力，确保不发生系统性金融风险。",
          text2:
            "在4月25日举行的中央政治局学习会上，习近平再次强调，党的十八大以来，我们反复强调要把防控金融风险放到更加重要的位置，牢牢守住不发生系统性风险底线，采取一系列措施加强金融监管，防范和化解金融风险，维护金融安全和稳定。两次会议，一个基调，就是“防范金融风险，维护金融稳定”。",
          text3:
            "保险业是现代金融业的重要组成部分，防范保险业风险对于维护金融安全和稳定至关重要。和其他很多行业不同，保险业仍处在奋发向上、砥砺有为的黄金机遇期。",
          text4:
            "在这样一个历史机遇期，保险业除了以积极心态拥抱成长外，尤需小心谨慎，以如履薄冰的心态对待各项业务，尽可能做到收放自如；切不可孤军冒进，将自己暴露于巨大的风险敞口下。",
          text5:
            "保险业在尽力满足社会方方面面的风险管理需求的同时，要时刻紧绷风险防范这根弦。你在替别人管理风险的背后，更要筑起防范自身风险的长城。",
          text6:
            "总之，要全面领会中央对金融形势和金融风险的分析判断，深刻认识维护国家金融安全的极端重要性，切实把防控金融风险贯穿到保险监管工作的全过程。",
          text7:
            "在工作中，始终把防范风险摆在突出位置，对待市场上的“坏孩子”毫不手软；同时坚守“保险业姓保、保监会姓监”不动摇。只有这样，保险业发展之路才会越走越宽。"
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.new_con {
  background-color: #fff;
  padding: 60px 40px 40px 40px;
  h4 {
    color: #477dbd;
    font-size: 30px;
    font-weight: 600;
    line-height: 48px;
  }
  span {
    color: #b6b6b6;
    font-size: 16px;
  }
  img {
    display: block;
    margin: 100px auto;
  }
  p {
    font-size: 24px;
    color: #656565;
    text-indent: 2em;
    padding-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NewsContent.vue